import React, { createContext, useContext, useMemo, useRef, useCallback } from 'react';

const FormFocusContext = createContext(null);

export function FormFocusProvider({ children }) {

  const rtgSynChildCount = 4 // Max child count

  const childRefs = useRef([]);

  for (let i = 0; i < rtgSynChildCount; i++) {
    if (!childRefs.current[i]) {
      childRefs.current[i] = {
        sex: React.createRef(),
        insuredTypes: React.createRef(),
      };
    }
  }
  const refs = useMemo(() => ({
    rtgHealthStyle: React.createRef(),
    rtgSex: React.createRef(),
    rtgSynChildProtectionRiders: React.createRef(),
    childRefs: childRefs.current,  // Dictionary of refs for children
  }), [childRefs]);

  const focusField = useCallback((field, index = null, subField = null) => {
    if (index !== null && subField && refs.childRefs[index]?.[subField]?.current) {
      refs.childRefs[index][subField].current.focus();
    } else {
      refs[field]?.current?.focus();
    }
  }, [refs]);

  return (
    <FormFocusContext.Provider value={useMemo(() => ({ refs, focusField }), [refs, focusField])}>
      {children}
    </FormFocusContext.Provider>
  );
}

export function useFormFocus() {
  const context = useContext(FormFocusContext);
  if (!context) {
    throw new Error('useFormFocus must be used within a FormFocusProvider');
  }
  return context;
}